import Vue from 'vue';
import App from './App.vue';
import './plugins/element.js';
import router from './router';
import ElementUI from 'element-ui';
import './assets/css/theme/index.scss'; // 引入自定义主题

window.config = {
  // api: 'http://xfadmin.feitem.com/',
  api: 'http://xfadmin.feitem.com/',
  // api: 'http://ollama.emcn.com.cn:7002/',
  //api: 'http://vrdj.l/',
};

//Vue.config.productionTip = false;

// 注册 ElementUI
Vue.use(ElementUI); 

// router.beforeEach((to, from, next) => {
//   // 禁止直接访问 /createorder
//   if (!(from.path ==='/cart') && to.path === '/createorder') {
//     //跳转到首页
//     next('/');
//   } else {
//     next(); // 允许导航
//   }
// });

new Vue({
  router, // 在这里注册 router
  render: h => h(App),
}).$mount('#app');
